import { toEntries } from "shared/sample-frame-quantities";
import * as Frontend from "kmmp/frontend";
import * as V2 from "kmmp/orders/v2";
import { ExhaustiveCheckError } from "./errors";
import { capitalize } from "./utils";

export function getShadowBoxDescription(
    customization: Frontend.ShadowBoxCustomization | V2.ShadowBoxCustomization
): string {
    const hasEngraving =
        !!customization.engravingName || !!customization.engravingDate1 || !!customization.engravingDate2;
    const withEngravingMessage = hasEngraving ? "with engraving" : "(no engraving)";

    return `${customization.color} Prestige Shadow Box ${withEngravingMessage}`;
}

export function getSignatureJerseyDescription(
    customization: Frontend.SignatureJerseyCustomization | V2.SignatureJerseyCustomization
): string {
    return `${customization.package} ${customization.frame} frame Prestige Jersey`;
}

export function getSignaturePortraitDescription(
    customization: Frontend.SignaturePortraitCustomization | V2.SignaturePortraitCustomization
): string {
    return `${customization.package} ${customization.frame.name} frame Prestige Portrait`;
}

export function getPortraitDescription(
    customization: Frontend.PortraitCustomization | V2.PortraitCustomization
): string {
    let withCardsMessage: string;

    switch (customization.package) {
        case "CP15":
        case "CP25":
        case "CP35":
            withCardsMessage = "5 portrait cards";
            break;

        default:
            withCardsMessage = "no cards";
            break;
    }

    const orientation = customization.orientation === "landscape" ? "horizontal" : "vertical";

    return `${customization.package} ${customization.frame.name} Portrait (${orientation}) with ${customization.background.name} background, ${withCardsMessage}`;
}

function getSampleFrameDescription(quantities: Frontend.SampleQuantities | V2.SampleQuantities): string {
    const description = toEntries(quantities)
        .filter(kvp => kvp.total > 0)
        .map(kvp => `${kvp.total} ${capitalize(kvp.key)}`);

    if (description.length === 0)
        return "Samples";

    return "Samples with " + description.join(", ");
}

export function getLineItemDescription(lineItem: Frontend.LineItem | V2.LineItem): string {
    switch (lineItem.type) {
        case undefined:
        case "portrait":
            return getPortraitDescription(lineItem.customization);

        case "shadow-box":
            return getShadowBoxDescription(lineItem.customization);

        case "signature-jersey":
            return getSignatureJerseyDescription(lineItem.customization);

        case "signature-portrait":
            return getSignaturePortraitDescription(lineItem.customization);

        case "sample-portraits":
            return getSampleFrameDescription("qty" in lineItem ? lineItem.qty : lineItem.quantities);

        default:
            throw new ExhaustiveCheckError(lineItem);
    }
}
